/**
 * Shared collection filter sidebar.
 *
 * Drives the multi-group filter used by both the Collection List section
 * (cards: .resource-list__item) and the Collection Tab Section
 * (cards: .itg_collection_list). It is selector-agnostic: each sidebar is
 * scoped to its own .shopify-section, and cards are found by their
 * data-filter-<group> attributes rather than a hardcoded class.
 *
 * Logic: AND across groups, OR within a group. A "Clear all" button (if
 * present) appears only while something is selected and resets every box.
 */
(function () {
  var GROUPS = ['style', 'colour', 'material', 'construction', 'shape'];
  var CARD_SELECTOR = GROUPS.map(function (g) {
    return '[data-filter-' + g + ']';
  }).join(',');

  function initFilter(sidebar) {
    // Scope to the section so cards and checkboxes don't bleed across sections.
    var root = sidebar.closest('.shopify-section') || document;
    var checkboxes = sidebar.querySelectorAll('.itg_filter_checkbox');
    var cards = root.querySelectorAll(CARD_SELECTOR);
    var clearBtn = sidebar.querySelector('[data-filter-clear]');
    var emptyEl = root.querySelector('[data-filter-empty]');
    if (!checkboxes.length || !cards.length) return;

    function applyFilter() {
      // Collect the checked values, keyed by their filter group. A group with
      // no checked boxes is left out entirely (it imposes no constraint).
      var selected = {};
      GROUPS.forEach(function (g) {
        var checked = sidebar.querySelectorAll(
          '.itg_filter_checkbox[data-filter-group="' + g + '"]:checked'
        );
        if (checked.length) {
          selected[g] = Array.prototype.map.call(checked, function (cb) {
            return cb.value;
          });
        }
      });
      var activeGroups = Object.keys(selected);

      // The "Clear all" button only appears once something is selected.
      if (clearBtn) clearBtn.hidden = activeGroups.length === 0;

      var visibleCount = 0;
      cards.forEach(function (card) {
        // No filter selected: show every collection card (default state).
        if (activeGroups.length === 0) {
          card.classList.remove('itg-filtered-out');
          visibleCount++;
          return;
        }

        // AND across groups, OR within a group: the card must satisfy every
        // active group, and within a group it matches if it carries ANY of
        // that group's checked values.
        var matchesAll = activeGroups.every(function (g) {
          var raw = (card.getAttribute('data-filter-' + g) || '').toLowerCase();
          var cardValues = raw
            .split('||')
            .map(function (v) { return v.trim(); })
            .filter(Boolean);
          return selected[g].some(function (val) {
            return cardValues.indexOf(val) !== -1;
          });
        });

        card.classList.toggle('itg-filtered-out', !matchesAll);
        if (matchesAll) visibleCount++;
      });

      // Show the empty-state message in place of the grid when nothing matches.
      if (emptyEl) emptyEl.hidden = visibleCount > 0;
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', applyFilter);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        applyFilter();
      });
    }
  }

  // "+ show more / - show less" toggle for filter groups with more than the
  // collapsed-count of options. Independent of the filtering logic — it only
  // reveals/hides the extra options (.itg_filter_item--extra) within a group.
  function bindShowMore(scope) {
    (scope || document)
      .querySelectorAll('[data-filter-more]')
      .forEach(function (btn) {
        if (btn.dataset.moreBound) return;
        btn.dataset.moreBound = '1';
        btn.addEventListener('click', function () {
          var group = btn.closest('.itg_filter_group');
          if (!group) return;
          var expanded = group.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          btn.textContent = expanded ? '- show less' : '+ show more';
        });
      });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-filter-sidebar]')
      .forEach(initFilter);
    bindShowMore(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
